var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.seconds_variety > 0)?_c('span',[_vm._v(" （"+_vm._s(_vm.show_minutes)+":"+_vm._s(_vm.show_seconds)+"） ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }